<template>
  <div class="common-nio-form" v-if="config && config.length">
    <section v-for="(item, i) in config" :key="i" class="common-nio-form__form-item">
      <component :is="item.type | compNameFilter"
                 v-model="formData[item.key || item.id]"
                 :disabled="disabled || item.disabled"
                 :placeholder="item | placeholderFilter"
                 :options="item.options"
                 @change="handleChange(i)"
                 v-bind="item.props || {}"></component>
      <template v-if="status[i]">
        <p class="common-nio-form__error-msg" v-if="!status[i].valid">
          {{ status[i].errorMsg }}
        </p>
      </template>
    </section>
  </div>
</template>

<script>
/*
 * nio 表单
 */
import NioInput from '@/components/ui/NioInput';
import NioSelect from '@/components/ui/NioSelect';
import NioMobileInput from '@/components/ui/NioMobileInput';

const formItemMap = {
  input: 'nio-input',
  // compose: 'nio-mobile-input',
  select: 'nio-select',
  mobile_input: 'nio-mobile-input'
};

export default {
  name: 'NioForm',
  components: {
    NioInput,
    NioSelect,
    NioMobileInput
  },
  props: {
    config: {
      type: Array
    },
    rules: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      status: this.config.map(() => ({valid: true, errorMsg: ''}))
    };
  },
  computed: {
    formData: {
      get(){
        let formData = {};

        this.config.forEach(item => {
          let val = item.default_value || item.defaultValue || '';

          formData[item.key || item.id] = val;
        });
        return formData;
      }
    }
  },
  watch: {
    config(val){
      if (val && val.length){
        this.status = val.map(() => ({valid: true, errorMsg: ''}));
      }
    }
  },
  methods: {
    validateAll(){
      return new Promise((resolve) => {
        let result = true;

        this.config.forEach((item, i) => {
          const check = this.checkValue(item, this.formData[item.key || item.id]);

          if (!check.valid){
            this.status[i].valid = false;
            this.status[i].errorMsg = check.error;
            result = false;
          }
        });

        if (result){
          resolve(this.formData);
        }
      });
    },
    checkValue(item, value){
      const result = {
        valid: true,
        error: ''
      };

      const setError = msg => {
        result.valid = false;
        result.error = msg;
      };

      const setSuccess = () => {
        result.valid = true;
        result.error = '';
      };

      const validValue = (val, itemConf) => {
        const isString = typeof val === 'string';

        if (itemConf.required && isString && (!val || !val.trim())){
          // 非空字符串
          setError(item.errorMsg.empty || `${item.label} ${this.$t('content.commonFormItemRequired')}`);
          return;
        }
        if (val){
          if (itemConf.regex && isString && !new RegExp(itemConf.regex).test(val)){
            // 正则字符串校验
            setError(itemConf.errorMsg.regex || `${item.label} ${this.$t('content.commonFormItemInvalid')}`);
            return;
          }
          if (itemConf.max && isString && val.trim().length > itemConf.max){
            // 字符串长度校验
            setError(itemConf.errorMsg.limit || `${item.label} ${this.$t('content.commonFormItemInvalid')}`);
            return;
          }
          if (itemConf.max && !isString && val > itemConf.max){
            // 数字大小最大限制
            setError(itemConf.errorMsg.max || `${item.label} ${this.$t('content.commonFormItemInvalid')}`);
            return;
          }
          if (itemConf.min && !isString && val < itemConf.min){
            // 数字大小最小限制
            setError(itemConf.errorMsg.min || `${item.label} ${this.$t('content.commonFormItemInvalid')}`);
            return;
          }
        }
        setSuccess();
      };

      if (item.type === 'compose' && item.sub_widgets && item.sub_widgets.length){
        // 组合类型表单校验
        // TODO
        // item.sub_widgets.forEach(subWidgetsConf => {
        //   validValue(value[subWidgetsConf.id], subWidgetsConf);
        // });
      } else if (item.type === 'mobile_input'){
        // 校验手机
        if (item.required && !value['calling_code']){
          setError(item.empty || `${item.label} ${this.$t('content.commonFormItemRequired')}`);
        }
        validValue(value.number, item);
      } else {
        // 通用校验
        validValue(value, item);
      }
      return result;
    },
    handleChange(i){
      this.status[i].valid = true;
      this.status[i].errorMsg = '';
    }
  },
  filters: {
    compNameFilter(value){
      return formItemMap[value] || 'div';
    },
    placeholderFilter(item){
      let str = item.label || item.placeholder || '';

      if (str && item.required){
        str += ' *';
      }
      return str;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/standard";

.common-nio-form {
  &__form-item {
    margin-bottom: sizeTrans($space_15);
    padding: sizeTrans($space_15) 0;
  }
  &__error-msg {
    margin-top: sizeTrans(18);
    color: $color_gr1_front;
    @include font_tips_xs($height_m);
  }
}
</style>